(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.directive('additionalInfo', [AdditionalInfoFn]);

    /* display an additional info */
    function AdditionalInfoFn() {
        // use parent scope to enable validation
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/users/templates/user-additionalinfo.template.html',
            scope: {
                additionalInfo: '=',
                additionalInfos: '='
            },
            replace: true
        };
        return directive;

        function link(scope, element, attrs) {
            if (!scope.additionalInfo) { return; }
            activate();

            /* do activation work */
            function activate() {
            }

            /* delete an additional info */
            scope.deleteAdditionalInfo = function () {
                // delete item from array
                scope.additionalInfos.splice(scope.additionalInfos.indexOf(scope.additionalInfo), 1);
            };
        }
    }

})();